module.exports = __webpack_public_path__ + "fonts/helvetica_neu_bold-webfont.0bb873be.woff";